module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Встреча завершена","description":"Организатор завершил видеособеседование. Спасибо за участие.","action":"Перейти на Huntica"}}')
  delete Component.options._Ctor
}
